import environment from "environment";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import HttpUtility from "../../utilities/HttpUtility";
import { AxiosResponse } from "axios";
import EffectUtility from "../../utilities/EffectUtility";
import ResponseEsitoModel from "stores/shared/models/ResponseEsitoModel";
import PraticaInfoPraticaRequestModel from "./models/PraticaInfoPraticaRequestModel";
export default class PraticaEffect {
    public static async requestCreaPraticaCqsOnline(
        idPreventivo: number
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.creaPraticaCQSonline;
        return EffectUtility.getToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, {
            idPreventivo: idPreventivo,
        });
    }

    public static async requestGetInfoPratica(
        idPreventivo: number
    ): Promise<PraticaInfoPraticaRequestModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getInfoPratica;
        return EffectUtility.getToModel<PraticaInfoPraticaRequestModel>(PraticaInfoPraticaRequestModel, endpoint, {
            idPreventivo: idPreventivo,
        });
    }

    /**
     * This is only to trigger an error api response so we can use it for an example in the AboutPage
     */
    public static async requestError(): Promise<any | HttpErrorResponseModel> {
        const endpoint: string = environment.api.errorExample;
        const response: AxiosResponse | HttpErrorResponseModel = await HttpUtility.get(endpoint);

        if (response instanceof HttpErrorResponseModel) {
            return response;
        }

        return response.data;
    }
}
